class ReactFilterSelection extends React.Component {

    constructor(props) {
        super(props);
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        return {
            values: this.refs.combo.getValues()
        };
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if (values.values) {
            this.refs.combo.setValues({
                value: values.values
            })
        } else {
            this.clearValues();
        }
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.refs.combo.clearValues()
    }

    render() {

        var fieldOptions = this.props.settings.field_options;
        if (fieldOptions) {
            fieldOptions = JSON.parse(fieldOptions);
        }

        var createOpts = {
            ref: 'combo',
            label: this.props.label,
            value: this.props.settings.values,
            idField: 'value',
            displayField: 'text',
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid
        };

        if (fieldOptions && fieldOptions.values) {
            createOpts.records = fieldOptions.values;
        }
        if (fieldOptions && fieldOptions.url) {
            createOpts.url = fieldOptions.url;
        }
        if (this.props.settings.limit_options) {
            createOpts.limitOptions = this.props.settings.limit_options;
        }

        if (fieldOptions && fieldOptions.isManualStore) {
            var records = [];

            if (this.props.settings.values) {
                this.props.settings.values.forEach(function (value) {
                    records.push({
                        text: value,
                        value: value
                    })
                });
            }
            if (parseInt(this.props.settings.values_as_options)) {
                createOpts.value = null;
            }
            createOpts.records = records;
        }

        return React.createElement(ReactFilterCombo, createOpts);
    }
}

ReactFilterSelection.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};